var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed pin-l w-full mx-auto my-3 px-6 bg-blue z-30 shadow"},[_c('div',{staticClass:"container py-3"},[_c('div',{staticClass:"flex justify-between mx-3"},[_vm._t("left"),_vm._t("right")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }